<!-- a11y: prevent default browser submit on Enter / mobile "Search" key; see search-station-form for full rationale. -->
<form
  [formGroup]="routePlannerForm"
  class="relative overflow-x-hidden overflow-y-visible"
  (ngSubmit)="submitRoutePlannerForm()"
>
  <div class="flex flex-col gap-4">
    <div cdkDropList (cdkDropListDropped)="drop($event)" [class]="direction"
      class="flex flex-col gap-4 bg-white rounded-b-xl p-4 shadow-lg">
      <mot-autocomplete formControlName="origin" [readOnly]="true" [displayErrors]="false" appearance="fill"
        inputIcon="arrow-down-arrow-up"
        inputIconClass="cursor-pointer text-2xl text-white ml-2 p-1 bg-primary rounded-3xl" inputClass="cursor-pointer"
        [label]="originText" (onClick)="openAutocomplete(getFormControl('origin'), searchOriginText, 'origin')"
        (onIconClick)="switchLocations()" [iconButtonAriaLabel]="switchLocationsText"
        fieldClass="cursor-pointer bg-transparent w-full !text-default"
        [displayFn]="routePlanningService.displayAddressName"  />

        <!-- <div *ngIf="stopAddresses.length > 0" class="stops-container flex flex-col gap-4">
        <div cdkDrag cdkDragBoundary=".stops-container" [cdkDragDisabled]="stopAddresses.length <= 1"
          class="flex gap-2 items-center" *ngFor="let stopAddress of stopAddresses; let i = index">
          <ng-icon *ngIf="stopAddresses.length > 1" cdkDragHandle class="text-lg cursor-pointer" name="" />
            <mot-autocomplete appearance="fill" [readOnly]="true" formControlName="stops" [displayErrors]="false"
              inputIconClass="cursor-pointer text-2xl ml-3" inputIcon="trash" (onIconClick)="removeStop(i)"
            class="!w-full" (onClick)="
              openAutocomplete(getFormControl('stops'), 'הוסף עצירה', 'stop')
            " fieldClass="!w-full !text-default" placeholder="בחר עצירה" [displayFn]="displayAddressName"
              [options]="stopAddress" />
            </div>
          </div> -->

          @if (showStopInput) {
            <!--
              a11y: trash-icon button used to announce "סגור" (close) — wrong
              for SR users since activating it deletes the optional stop, it
              doesn't close anything. Now labelled "מחיקת עצירה" / "Delete
              stop" via the new DELETE_STOP constant.
            -->
            <mot-autocomplete #stopMotAutocomplete appearance="fill" [readOnly]="true" formControlName="stop"
              [displayErrors]="false" inputClass="align-sub" inputIconClass="cursor-pointer text-2xl ml-3" inputIcon="trash"
              (onIconClick)="closeStop()" [iconButtonAriaLabel]="deleteStopText" class="!w-full" (onClick)="openAutocomplete(getFormControl('stop'), addStopText, 'stop')"
              fieldClass="!w-full !text-default" [label]="pickStopText"
              [displayFn]="routePlanningService.displayAddressName" />
          }

          <mot-autocomplete formControlName="destination" [readOnly]="true" appearance="fill" [displayErrors]="false"
        fieldClass="w-full !text-default" inputClass="cursor-pointer" [label]="destinationText" (onClick)="
          openAutocomplete(getFormControl('destination'), searchDestinationText, 'destination')
        " [displayFn]="routePlanningService.displayAddressName" />

            <span class="flex gap-8 items-center">
              <mot-button type="button" icon="plus" (onClick)="openStop()" [disableRipple]="true"
                [ngClass]="{ '!text-gray-100 !cursor-not-allowed': showStopInput }"
                buttonClass="!text-default font-bold !shadow-none !py-0 px-2 !bg-transparent text-base " [text]="addStopText"
                iconClass="!text-2xl" [textClass]="showStopInput ? 'text-gray-400' : ''"
                [iconClass]="showStopInput ? 'text-gray-400' : ''" [disabled]="showStopInput" />

                <mot-button type="button" icon="bars-filter" (onClick)="openFilterMenu()" [disableRipple]="true"
                  buttonClass="!text-default font-bold !shadow-none !py-0 px-2 !bg-transparent text-base"
                  [textClass]="(appliedFilters$ | async) ? 'filters-active' : ''" iconClass="!text-2xl" [text]="filterText"
                  ariaHaspopup="dialog" />
                </span>
              </div>

              <mot-date-time-picking-form class="px-4" [arrivalFormGroup]="getNestedGroup('arrival')"
                [departureFormGroup]="getNestedGroup('departure')" [timeOptFormControl]="getFormControl('timeOpt')" />

                <app-favorite-routes (onFavoriteRouteClick)="handleFavoriteRouteClick($event)" class="w-full" />
              </div>
            </form>